"use client";

import { createContext, type ReactNode } from "react";

import { type RoomTier, type SearchPassengers } from "@trip/constants";
import { type getProposal } from "@trip/db";

import { type CartLinkQuery } from "~/lib/proposals";

import type { TripQueryData } from "./gql";
import { type getLineItem } from "./trip";

export type DatoTrip = NonNullable<TripQueryData["trip"]>;
export type DatoTripLocation = DatoTrip["tripDestinations"][number]["location"];
export type DatoTripHotel = DatoTripLocation["hotels"][number];

interface Destination {
  accommodationUpgrades: Record<RoomTier, number>;
  id: string;
  transfer: { transferIncluded: boolean };
  datoHotel: DatoTripHotel | null;
}

interface ContextProps {
  date: Date;
  nights: number;
  destinations: Destination[];
  passengers: SearchPassengers;
  total: number;
  datoTrip: DatoTrip;
  cartLink: CartLinkQuery | undefined;
  proposal: ReturnType<typeof getProposal>;
  transfersIncluded: boolean;
  lineItem: Awaited<ReturnType<typeof getLineItem>> | null;
}

export const TripContext = createContext<ContextProps | null>(null);

export function TripProvider({
  children,
  context,
}: {
  children: ReactNode;
  context: ContextProps;
}) {
  return <TripContext value={context}>{children}</TripContext>;
}
